"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistMeasurements = exports.getMeasurements = exports.clearMeasurements = exports.getCumulativeMeasure = exports.endMeasure = exports.measure = exports.now = void 0;
const debug_1 = __importDefault(require("./debug"));
const global_1 = require("./global");
const debug = debug_1.default('cs:measurements');
const runningMeasurements = new Map();
let measurements = {};
const global = global_1.getGlobal();
if (typeof global.performance === 'undefined') {
    global.performance = {
        mark: () => { },
        now: () => Date.now(),
        measure: () => { },
    };
}
function now() {
    try {
        return performance.now();
    }
    catch (err) {
        console.warn(err);
        return 0;
    }
}
exports.now = now;
function measure(key) {
    try {
        performance.mark(`${key}_start`);
        const currentTime = now();
        runningMeasurements.set(key, currentTime);
        return currentTime;
    }
    catch (e) {
        console.warn(`Something went wrong while adding measure: ${e.message}`);
        return 0;
    }
}
exports.measure = measure;
function endMeasure(key, options = {}) {
    try {
        const { lastTime } = options;
        performance.mark(`${key}_end`);
        const lastMeasurement = typeof lastTime === 'undefined' ? runningMeasurements.get(key) : lastTime;
        if (typeof lastMeasurement === 'undefined') {
            console.warn(`Measurement for '${key}' was requested, but never was started`);
            return 0;
        }
        const nowMeasurement = performance.now();
        measurements[key] = nowMeasurement - lastMeasurement;
        if (!options.silent) {
            debug(`${options.displayName || key} Time: ${measurements[key].toFixed(2)}ms`);
        }
        const hadKey = runningMeasurements.delete(key);
        performance.measure(key, hadKey ? `${key}_start` : undefined, `${key}_end`);
        return measurements[key];
    }
    catch (e) {
        console.warn(`Something went wrong while adding measure: ${e.message}`);
        return 0;
    }
}
exports.endMeasure = endMeasure;
/**
 * Get the cumulative of a specific measurement by prefix. If you had for example these measurements:
 * - transpile-index.js
 * - transpile-test.js
 *
 * You can get the sum of these measurements with getCumulativeMeasure('transpile', 'Transpilation')
 */
function getCumulativeMeasure(prefix, options = {}) {
    const keys = Object.keys(measurements).filter(p => p.startsWith(prefix + '-'));
    const totalTime = keys.reduce((prev, key) => prev + measurements[key], 0);
    if (!options.silent) {
        debug(`${options.displayName || prefix} Total Time: ${totalTime.toFixed(2)}ms`);
        debug(`  Average Time: ${(totalTime / keys.length).toFixed(2)}ms`);
    }
    return totalTime;
}
exports.getCumulativeMeasure = getCumulativeMeasure;
function clearMeasurements() {
    measurements = {};
    runningMeasurements.clear();
}
exports.clearMeasurements = clearMeasurements;
function getMeasurements() {
    return measurements;
}
exports.getMeasurements = getMeasurements;
global_1.getGlobal().measurements = {
    clearMeasurements,
    getCumulativeMeasure,
    getMeasurements,
};
const MEASUREMENT_API = `https://col.csbops.io/data/sandpack`;
function persistMeasurements(data) {
    const body = [
        {
            measurement: 'load_times',
            tags: {
                browser: data.browser,
                cache_used: data.cacheUsed,
                version: data.version,
            },
            fields: {
                transpilation: measurements.transpilation,
                evaluation: measurements.evaluation,
                external_resources: measurements['external-resources'],
                compilation: measurements.compilation,
                boot: measurements.boot,
                total: measurements.total,
                dependencies: measurements.dependencies,
            },
        },
    ];
    if (process.env.NODE_ENV === 'development' || process.env.STAGING) {
        // eslint-disable-next-line
        console.log(body);
        return Promise.resolve();
    }
    return fetch(MEASUREMENT_API, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
}
exports.persistMeasurements = persistMeasurements;
